import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('xs')]: { paddingLeft: 16, paddingRight: 16 },
    [theme.breakpoints.up('xs')]: {
      paddingLeft: 23,
      paddingRight: 23
    },
    [theme.breakpoints.up('md')]: {
      paddingLeft: 23,
      paddingRight: 0
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 41.5,
      paddingRight: 18.5
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 80,
      paddingRight: 80
    }
  },
  list: {
    [theme.breakpoints.down('xs')]: { paddingTop: 20, paddingRight: 0, paddingBottom: 20 },
    [theme.breakpoints.up('sm')]: { paddingTop: 40, paddingBottom: 40 },
    [theme.breakpoints.up('md')]: { paddingRight: 23 }

  },
  card: {
    height: 306,
    marginTop: 13,
    color: '#2A324F',
    background: '#FFFFFF',
    boxShadow: 'none'
  },
  notFound: {
    marginTop: 12,
    marginBottom: 8,
    marginLeft: 16,
    marginRight: 16,
    paddingTop: 2,
    paddingBottom: 2
  }
}));
